import React from "react";
import { motion } from "framer-motion";
import { FaMugHot, FaShoppingBag, FaCheckCircle } from "react-icons/fa";
import { GiCoffeeBeans, GiCoffeeCup } from "react-icons/gi";
import { MdLocalCafe } from "react-icons/md";

const timelineData = [
  {
    id: 1,
    icon: <GiCoffeeBeans className="text-amber-950 w-6 h-6" />,
    title: "مقدمه",
    description: "تصور کنید یک روز صبح زود، با شوق دم کردن اولین فنجان قهوه روزانه‌تان بیدار می‌شوید. بسته‌ی قهوه‌ای را که تازه خریده‌اید باز می‌کنید، اما به جای عطر دل‌انگیز و رایحه تازه، بوی کهنگی و بی‌روحی به مشام‌تان می‌رسد. جرعه‌ای که می‌نوشید، نه تنها انرژی‌بخش نیست بلکه حس ناامیدی به شما می‌دهد. دلیلش ساده است: نگهداری نادرست قهوه.چه در خانه و چه در کارخانه، رعایت اصول نگهداری باعث می‌شود دانه‌ها و پودر قهوه تازگی، طعم و خواص واقعی خود را حفظ کنند. در این مقاله جامع، به بررسی علمی و کاربردی روش‌های نگهداری قهوه در هر دو مقیاس خانگی و صنعتی می‌پردازیم."
  },
  {
    id: 2,
    icon: <MdLocalCafe className="text-amber-900 w-6 h-6" />,
    title: "دشمنان اصلی قهوه",
    description:
      "۱. اکسیژن: باعث اکسید شدن ترکیبات معطر می‌شود.    ۲. نور: کیفیت قهوه را کاهش می‌دهد. ۳. رطوبت: قهوه را کپک‌زده یا بی‌طعم می‌کند. ۴. حرارت: روند کهنگی را تسریع می‌کند.",
  },
  {
    id: 3,
    icon: <FaMugHot className="text-amber-800 w-6 h-6" />,
    title: "اشتباهات رایج ایرانی‌ها",
    description:
      "- گذاشتن قهوه در یخچال یا فریزر. - نگهداری در ظروف شفاف روی کابینت. - خرید بیش از حد و انبار طولانی‌مدت. - باز گذاشتن بسته یا ظرف قهوه.",
  },
  {
    id: 4,
    icon: <GiCoffeeCup className="text-amber-700 w-6 h-6" />,
    title: "نگهداری قهوه در خانه",
    description:
      "۱. خرید به اندازه نیاز. ۲. استفاده از ظروف مات و دربسته. ۳. نگهداری در جای خشک و خنک. ۴. استفاده از بسته‌بندی سوپاپ‌دار. ۵. آسیاب کردن فقط قبل از دم‌آوری.",
  },
  {
    id: 5,
    icon: <FaShoppingBag className="text-amber-600 w-6 h-6" />,
    title: "نگهداری قهوه در کارخانه و کارگاه‌ها",
    description:
      "۱. سیلوهای استاندارد برای دانه سبز. ۲. کنترل دما (۱۸–۲۴ درجه) و رطوبت. ۳. بسته‌بندی صنعتی چندلایه سوپاپ‌دار. ۴. عدم نگهداری طولانی (حداکثر ۲ ماه).",
  },
  {
    id: 6,
    icon: <FaCheckCircle className="text-amber-500 w-6 h-6" />,
    title: "استانداردهای جهانی و صادرات",
    description:
      "انبارهای تخصصی با کنترل رطوبت، استفاده از کیسه‌های چندلایه و GrainPro، درج تاریخ رُست و اطلاعات کامل روی بسته، و تست‌های مایکوتوکسین در برخی کشورها.",
  },
  {
    id: 7,
    icon: <FaMugHot className="text-amber-700 w-6 h-6" />,
    title: "سوالات متداول",
    description:
      "- آیا نگهداری در یخچال درست است؟ خیر. - قهوه باز شده چند روز می‌ماند؟ حداکثر ۲ هفته. - آیا قهوه سبز شرایط خاص می‌خواهد؟ بله. - تفاوت خانه و کارخانه؟ کنترل شرایط دقیق‌تر در کارخانه.",
  },
  {
    id: 8,
    icon: <FaCheckCircle className="text-amber-600 w-6 h-6" />,
    title: "جمع‌بندی",
    description:
      "قهوه محصولی زنده است و حتی پس از رُست هم تغییر می‌کند. دشمنانش نور، هوا، رطوبت و گرما هستند. با رعایت اصول نگهداری در خانه و کارخانه، می‌توان طعم واقعی قهوه را حفظ کرد.",
  },
];

export const CoffeeStoragePage = () => {
  return (
    <section className="min-h-screen bg-gradient-to-br from-[#f8ede3] via-[#e6ccb2] to-[#ddb892] py-16 px-4 sm:px-6 lg:px-12">
      <div className="relative max-w-5xl mx-auto">
        {/* Timeline Line */}
        <div className="absolute left-1/2 top-0 bottom-0 w-[2px] -translate-x-1/2 bg-gradient-to-b from-amber-400 to-amber-700 opacity-40"></div>

        <div className="space-y-20 relative">
          {timelineData.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
              className={`flex flex-col sm:flex-row items-center gap-6 ${
                index % 2 === 0 ? "sm:flex-row-reverse" : ""
              }`}
            >
              {/* Text Box */}
              <div className="sm:w-1/2 bg-white border border-[#d6ccc2] rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300">
                <h3 className="text-lg sm:text-xl font-bold text-[#4e342e]">
                  {item.title}
                </h3>
                <p className="text-base text-stone-700 mt-3 leading-relaxed text-justify">
                  {item.description}
                </p>
              </div>

              {/* Icon */}
              <motion.div
                whileInView={{ scale: [0.8, 1], rotate: [10, 0] }}
                transition={{ duration: 0.5 }}
                className="flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-amber-100 to-amber-300 border-2 border-amber-600 shadow-lg z-10"
              >
                {item.icon}
              </motion.div>

              {/* Empty Spacer */}
              <div className="sm:w-1/2 hidden sm:block"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoffeeStoragePage;